let _ = t => t,
  _t;
import { Fragment, useMemo } from 'react';
import styledWithTheme from 'foundations-theming/utils';
import { AVATAR_SIZES, AVATAR_SOURCE_TYPES, DEFAULT_AVATAR_TYPES } from '../../Constants';
import { DEFAULT_ICON_MAP } from '../defaultSvgIcons';
import { AVATAR_SOURCES } from '../../lib/AvatarSources';
import { AvatarContactInitials } from './AvatarContactInitials';
import { AvatarImage } from './AvatarImage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledContentWrapper = styledWithTheme.div(_t || (_t = _`
  svg {
    fill: ${0} !important;
    color: ${0} !important;
  }
`), ({
  $iconColor
}) => $iconColor, ({
  $iconColor
}) => $iconColor);
export const AvatarContent = ({
  'data-test-id': dataTestId,
  displayName,
  iconColor,
  iconType,
  size,
  source,
  src
}) => {
  const AvatarIcon = iconType ? DEFAULT_ICON_MAP[iconType] : Fragment;
  const isHubSpotUserAvatarSource = source === AVATAR_SOURCES.HUBSETTINGS_HUBSPOT_USER;
  const parsedSize = size === 'responsive' ? '100%' : AVATAR_SIZES[size];
  const defaultAvatarContent = useMemo(() => {
    if (src && !isHubSpotUserAvatarSource) return null;
    if (iconType === DEFAULT_AVATAR_TYPES.CONTACT) {
      return /*#__PURE__*/_jsx(AvatarContactInitials, {
        size: size,
        displayName: displayName
      });
    }
    return /*#__PURE__*/_jsx(AvatarIcon, {});
  }, [src, iconType, displayName, size, AvatarIcon, isHubSpotUserAvatarSource]);
  return /*#__PURE__*/_jsxs(StyledContentWrapper, {
    $iconColor: iconColor,
    "data-test-id": dataTestId || 'AvatarDisplay-avatarContent',
    children: [/*#__PURE__*/_jsx("svg", {
      width: parsedSize,
      height: parsedSize
    }), defaultAvatarContent, /*#__PURE__*/_jsx(AvatarImage, {
      "data-test-id": "avatar-svg-image",
      $src: src || '',
      "data-source": AVATAR_SOURCE_TYPES.KNOWN_SRC
    })]
  });
};